import * as numeral from 'numeral';

const FormatNumber = (input, format, prefix) =>
  (typeof prefix === 'undefined' ? '£' : '') + numeral(input).format(format);

export default {
  install(Vue) {
    Vue.filter('commas', value => FormatNumber(value, '0,0', ''));
    Vue.filter('currency', (value, prefix) => FormatNumber(value, '0,0.00', prefix));
    Vue.filter('prefix', (value, prefix) => `${prefix}${value}`);
  },
};
